import { WdiInput, WdiModalAppProps, WdiTextArea, wdiCore } from "@/components/WdiControls";
import { WdiModalForm } from "@/components/WdiControls/WdiModalForm";
import { ResponseStatus } from "@/utils/request";
import { Form, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ProFormInstance } from "@ant-design/pro-form";
import { WdiInputNumber } from "@/components/WdiControls/WdiInputNumber";
import { FormSs } from "@/services/sales/ss";
import { Enum } from "@/enums/system";


const SettleDetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    formRef.current?.setFieldsValue(props.data.record);
    formRef.current?.setFieldsValue({
      discountRate: wdiCore.Number.RateToString(props.data.record.discountRate),
      undertakeRate: wdiCore.Number.RateToString(props.data.record.undertakeRate),
    });
    setIsUpdate(props.data.isUpdate);
  }, [props.data.record])

  return (
    <>
      <WdiModalForm
        formRef={formRef}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 12 }}
        labelAlign='left'
        layout="horizontal"
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose?.();
          },
        }}
        onFinish={async (values) => {
          const { ...entity } = values;
          let response;
          if (isUpdate) {
            response = await FormSs.Buttons.modifyAmount({
              pageTypeId: Enum.PageType.ACTIVITY_SETTLEMENT,
              formSsDetail: Object.assign({}, { ...props.data.record }, entity),
            });
          } else {
            response = await FormSs.Buttons.validateDetail({
              pageTypeId: Enum.PageType.ACTIVITY_SETTLEMENT,
              formSsDetail: Object.assign({}, { ...props.data.record }, entity),
            });
          }
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
            return;
          }
          message.success('保存成功!');
          if (props.onSave) {
            props.onSave({
              code: ResponseStatus.SUCCESS,
              data: Object.assign({}, { ...props.data.record }, response.data)
            });
          }
          return true;
        }}
      >
        <Form.Item name='soldToName' label='客户' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='custSysName' label='客户系统' hidden={!props.data.fields.includes("custSysCode")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='shopName' label='门店' hidden={!props.data.fields.includes("shopId")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='productBuyNames' label='产品别' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='ecName' label='费用项' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='paymentMethodName' label='支付方式' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='amountSa' label='申请金额' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='amountActual' label='系统计算金额' hidden={!props.data.fields.includes("amountActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='amountPaid' label='已核销金额' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='amountPrePayment' label='预付金额' >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySs' label='结案数量' >
          <WdiInputNumber readOnly={isUpdate} format='d' digits={2} />
        </Form.Item>
        {isUpdate ?
          <>
            <Form.Item name='amountOriginal' label='原结案金额' >
              <WdiInput readOnly />
            </Form.Item>
            <Form.Item name='amount' label='新结案金额' rules={[{ required: true, message: '新结案金额不能为空' }]} >
              <WdiInputNumber format='d' digits={2} />
            </Form.Item>
            <Form.Item name='modifyReason' label='修改原因' >
              <WdiTextArea rows={4} />
            </Form.Item>
          </>
          :
          <Form.Item name='amount' label='结案金额' rules={[{ required: true, message: '结案金额不能为空' }]} >
            <WdiInputNumber format='d' digits={2} />
          </Form.Item>
        }
        <Form.Item name='amountAccrual' label='已预提金额' hidden={!props.data.fields.includes("amountAccrual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='rebateParameters' label='公式计算参数' hidden={!props.data.fields.includes("rebateParameters")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='amountCalc' label='公式计算金额' hidden={!props.data.fields.includes("amountCalc")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantityPosActualKeyin' label='实际POS销量（EA）(用户填写)'
          hidden={!props.data.fields.includes("quantityPosActualKeyin")} >
          <WdiInputNumber readOnly={isUpdate} format='d' digits={2} min={0} />
        </Form.Item>
        <Form.Item name='revenuePosActualKeyin' label='实际POS销额（用户填写）'
          hidden={!props.data.fields.includes("revenuePosActualKeyin")}>
          <WdiInputNumber readOnly={isUpdate} format='d' digits={2} min={0} />
        </Form.Item>
        <Form.Item name='remark' label='结案备注' >
          <WdiTextArea rows={4} readOnly={isUpdate} maxLength={2000}/>
        </Form.Item>
        <Form.Item name="pricePosBefore" label="终端原售价(最小单位)" hidden={!props.data.fields.includes("pricePosBefore")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="pricePosAfter" label="终端促销售价(最小单位)" hidden={!props.data.fields.includes("pricePosAfter")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="unitExpense" label="单位费用(EA)" hidden={!props.data.fields.includes("unitExpense")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="discountRate" label="折扣比例(%)" hidden={!props.data.fields.includes("discountRate")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="undertakeRate" label="公司承担比例(%)" hidden={!props.data.fields.includes("undertakeRate")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySellinForecast' label='SAP发货销量目标（EA）' hidden={!props.data.fields.includes("quantitySellinForecast")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySellinActual' label='实际SAP发货销量' hidden={!props.data.fields.includes("quantitySellinActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='revenueSellinForecast' label='SAP发货销额目标' hidden={!props.data.fields.includes("revenueSellinForecast")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='revenueSellinActual' label='实际SAP发货销额' hidden={!props.data.fields.includes("revenueSellinActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="quantityForecast2" label="销量目标2(EA)" hidden={!props.data.fields.includes("quantityForecast2")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="revenueForecast2" label="销额目标2" hidden={!props.data.fields.includes("revenueForecast2")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutForecast' label='门店入库销量目标（EA）' hidden={!props.data.fields.includes("quantitySelloutForecast")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutActual' label='实际门店入库销量' hidden={!props.data.fields.includes("quantitySelloutActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutForecast2' label='门店售出销量目标（EA）' hidden={!props.data.fields.includes("quantitySelloutForecast2")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutActual2' label='实际门店售出销量' hidden={!props.data.fields.includes("quantitySelloutActual2")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutForecast3' label='小听粉派发数量目标（EA）' hidden={!props.data.fields.includes("quantitySelloutForecast3")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutActual3' label='实际小听粉派发数量' hidden={!props.data.fields.includes("quantitySelloutActual3")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutForecast4' label='新客数量目标' hidden={!props.data.fields.includes("quantitySelloutForecast4")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutActual4' label='实际新客数量' hidden={!props.data.fields.includes("quantitySelloutActual4")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutForecast5' label='消费者扫码数量目标（EA）' hidden={!props.data.fields.includes("quantitySelloutForecast5")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantitySelloutActual5' label='实际消费者扫码数量' hidden={!props.data.fields.includes("quantitySelloutActual5")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='revenueSelloutForecast' label='门店入库销额目标' hidden={!props.data.fields.includes("revenueSelloutForecast")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='revenueSelloutActual' label='实际门店入库销额' hidden={!props.data.fields.includes("revenueSelloutActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="quantityPosForecast" label="POS销量目标(EA)" hidden={!props.data.fields.includes("quantityPosForecast")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='quantityPosActual' label='实际POS销量（EA）(系统计算)' hidden={!props.data.fields.includes("quantityPosActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="revenuePosForecast" label="POS销额目标" hidden={!props.data.fields.includes("revenuePosForecast")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name='revenuePosActual' label='实际POS销额（系统计算）' hidden={!props.data.fields.includes("revenuePosActual")} >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="displayTypeName" label="陈列形式" hidden={!props.data.fields.includes("displayTypeId")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="displayLocationName" label="陈列位置" hidden={!props.data.fields.includes("displayLocationId")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="displayArea" label="陈列面积" hidden={!props.data.fields.includes("displayArea")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="displayQuantity" label="陈列数量" hidden={!props.data.fields.includes("displayQuantity")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="promoterCount" label="促销员人数" hidden={!props.data.fields.includes("promoterCount")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="executionDate" label="执行日期" hidden={!props.data.fields.includes("executionDate")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="executionTimes" label="执行场次" hidden={!props.data.fields.includes("executionTimes")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="amountTeacher" label="讲师费" hidden={!props.data.fields.includes("amountTeacher")}>
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="revenueTypeName" label="核算类型" >
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="boName" label="四级使用部门">
          <WdiInput readOnly />
        </Form.Item>
        <Form.Item name="policyName" label="产品政策" hidden={!props.data.fields.includes("productPolicyId")}>
          <WdiInput readOnly />
        </Form.Item>
      </WdiModalForm>
    </>
  );
}
export default SettleDetailEditApp;
